module.exports = __webpack_public_path__ + "static/media/39.2d13bf1c.jpg";